module.exports = __webpack_public_path__ + "img/abs_pack.abac3185.png";